import { render } from "./AgencyPanel.vue?vue&type=template&id=6b8d267a"
import script from "./AgencyPanel.vue?vue&type=script&lang=js"
export * from "./AgencyPanel.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__